<div class="slide-box right" [ngClass]="{ 'slide-is-visible': show }" tabindex="-1" style="touch-action: manipulation;">
    <div class="slide-header">
        <span>{{ 'TrainingProviderAddByScannerHeader' | smartlabel: { fallback: 'Scan Attendee' } | async }}</span>
    </div>

    <button class="slide-close close-btn js-offline-supported"
            data-testid="12E8B73E-950D-49FF-BF3F-CABD2DF87543"
            (click)="onCloseSliderClicked()">
        <span class="sr-only">{{ 'GenericClose' | smartlabel: { fallback: 'Close' } | async }}</span>
    </button>

    <div class="app-module manager camera" id="camera-slider-body">
        <div class="camera-image-container">
            <zxing-scanner
                *ngIf="show" [enable]="show"
                [ngClass]="{ 'hide': !canUseCamera }"
                [(device)]="currentCamera"
                (autostarted)="onStarted()"
                (scanSuccess)="onScanSuccess($event)"
                (scanError)="onScanError($event)"
                (camerasFound)="onCamerasFound($event)"
                (camerasNotFound)="onCamerasNotFound()"
                (permissionResponse)="onPermissionResponse($event)"
                (torchCompatible)="onTorchCompatible($event)"
                [torch]="torchEnabled"></zxing-scanner>
            <div *ngIf="!canUseCamera && showErrorMessage" class="camera-error" id="camera-error">
                {{ 'TrainingProviderAddByScannerPermissionError' | smartlabel: { fallback: 'Camera access is currently blocked. If you change your mind, you can enable camera permissions in your device settings.' } | async }}
            </div>
        </div>
        <div class="camera-controls">
            <div class="camera-controls-container" id="camera-controls-container">
                <div class="camera-btn-container">
                    <button *ngIf="torchAvailable | async" (click)="onTorchClicked()" data-testid="238519C9-BED2-46B5-B4DF-0B54C08B080B"
                        class="camera-control-btn" aria-label="Toggle flash" id="camera-flash-btn">
                        <i class="fa fa-solid" [ngClass]="torchEnabled ? 'fa-bolt-slash' : 'fa-bolt'" aria-hidden="true"></i>
                    </button>
                </div>
                <div class="camera-btn-container">
                    <button *ngIf="canSwitchCameras" (click)="onSwitchCameraClicked()" data-testid="E232391F-DAAC-4C1C-91AD-4D4A19335E36"
                        class="camera-control-btn" aria-label="Switch camera">
                        <i class="fa fa-solid fa-camera-rotate" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>